/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamGradeCriteriaQueryResponse,
  GetApiV1ExamGradeCriteria401,
  GetApiV1ExamGradeCriteria500,
} from "../../types/examEvaluationController/GetApiV1ExamExamGradeCriteria.ts";

function getGetApiV1ExamExamGradeCriteriaUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/exam/exam-grade-criteria` as const,
  };
  return res;
}

/**
 * @description Retorna todos os critérios de nota disponíveis para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Listar critérios de nota para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-grade-criteria}
 */
export async function getApiV1ExamExamGradeCriteria(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamGradeCriteriaQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamGradeCriteria401 | GetApiV1ExamGradeCriteria500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamGradeCriteriaUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
